import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 2E95C78F-AAF9-4E1F-8241-4F781389EFF7
 * name compare-vertical
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/compare-vertical.svg
 * tags
 * - Arrow 
 */
export const CompareVerticalIcon = createSvgIcon(<><path d="M14 15V22H16V15H19L15 11L11 15H14M13 9H10V2H8V9H5L9 13L13 9Z" /></>, 'CompareVerticalIcon');
export default CompareVerticalIcon